import { render, staticRenderFns } from "./vueWithdrawal.vue?vue&type=template&id=87f6f972&scoped=true"
import script from "./vueWithdrawal.vue?vue&type=script&lang=js"
export * from "./vueWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./vueWithdrawal.vue?vue&type=style&index=0&id=87f6f972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f6f972",
  null
  
)

export default component.exports